import { WaitingScreen } from "./lib/WaitingScreen";
import PasswordSettingModal from "./component/PasswordSettingModal";

let passwordSettingModal: PasswordSettingModal;

declare global {
  interface Window {
    passwordSettingFlg: string | null;
  }
}

/**
 * 画面初期化イベント
 */
addEventListener("load", () => {
  // モーダル初期化
  passwordSettingModal = new PasswordSettingModal();

  // ログインフォームでsubmitされた時に割り込む
  const form = document.getElementById("form") as HTMLFormElement;
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    login();
  });

  // パスワード再設定が必要であればダイアログを表示する
  if (window.passwordSettingFlg == "1") {
    passwordSettingModal.show();
  }
});

/**
 * ログイン
 */
const login = () => {
  //フロントエンド側だけでデバッグ中の場合、ログイン処理を行わず会社選択画面に遷移
  if (import.meta.env.MODE === "development") {
    location.href = "./company.html";
    return;
  }
  WaitingScreen.show("ログイン中...");
  (document.getElementById("form") as HTMLFormElement).submit();
};
